import React from 'react';
import { without } from 'lodash';
import { useReactiveVar } from '@apollo/client';
import { Close as DeleteIcon } from '@mui/icons-material';
import { setInMemoryVar } from '../../../apollo/inMemoryVar';
import { appraisalViewCustomizationReports, STORAGE_KEYS } from '../appraisalViewCache';
import PracticeAreaGraphDescription from '../../shared/components/practiceAreaGraphList/PracticeAreaGraphDescription';

/**
 * @typedef {object} CustomizationTableDataOption
 * @property {string} label
 * @property {number} value
 * @property {boolean} [disabled]
 */

/**
 * @typedef {object} CustomizationTableReport
 * @property {CustomizationTableDataOption} practiceArea
 * @property {CustomizationTableDataOption} practiceGroupLevel
 * @property {CustomizationTableDataOption} appraisalProgramYear
 * @property {Array<*>} [deviceClasses]
 * @property {Array<*>} [ohts]
 * @property {boolean} [includeHigherLevels]
 * @property {boolean} [includeHigherProgramYears]
 * @property {boolean} [includeExactMatchedDeviceClasses]
 * @property {boolean} [includeExactMatchedOhts]
 * @property {string} uuid
 */

/**
 * @typedef {object} CustomizationTableProps
 * @property {CustomizationTableReport} report
 * @property {number} tableNumber
 */

/**
 * @param {CustomizationTableProps} props
 */
const CustomizationTable = props => {
  const { report, tableNumber } = props;

  const {
    practiceArea,
    practiceGroupLevel,
    appraisalProgramYear,
    deviceClasses,
    ohts,
    includeHigherLevels,
    includeHigherProgramYears,
    includeExactMatchedDeviceClasses,
    includeExactMatchedOhts
  } = report;

  const reports = useReactiveVar(appraisalViewCustomizationReports);

  const removeReport = report => {
    const newReports = without(reports, report);
    appraisalViewCustomizationReports(newReports);
    setInMemoryVar(STORAGE_KEYS.APPRAISAL_VIEW_REPORTS, newReports);
  };

  return (
    <div className='appraisal-view-customization__table'>
      <DeleteIcon
        className='appraisal-view-customization__table-adornment appraisal-view-customization__hover-pointer'
        onClick={() => removeReport(report)}
      />
      Table {tableNumber}{' '}
      <PracticeAreaGraphDescription
        ohts={ohts}
        deviceClasses={deviceClasses}
        practiceArea={{
          Name: practiceArea.label,
          DefaultLevel: practiceGroupLevel.value,
          Year: appraisalProgramYear.value,
          IncludeHigherLevels: includeHigherLevels,
          IncludeHigherProgramYears: includeHigherProgramYears,
          IncludeExactMatchedDeviceClasses: includeExactMatchedDeviceClasses,
          IncludeExactMatchedOhts: includeExactMatchedOhts
        }}
      />
    </div>
  );
};

export default CustomizationTable;
